import { Injectable } from '@angular/core';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';

@Injectable({
  providedIn: 'root'
})
export class CameraService {
  
  async takePhoto(options?: {
    quality?: number;
    resultType?: CameraResultType;
    allowEditing?: boolean;
    source?: CameraSource;
  }) {
    const photo = await Camera.getPhoto({
      source: options?.source ?? CameraSource.Camera,    // default live camera (no gallery)
      quality: options?.quality ?? 85,
      resultType: options?.resultType ?? CameraResultType.DataUrl, 
      allowEditing: options?.allowEditing ?? false,
      saveToGallery: false             // ensure it’s not stored back to gallery
    });
    return photo;
  }

}
